import { useContext } from 'react';
import { LocationContext } from './LocationContext';

export const useLocationPath = () => {
  const context = useContext(LocationContext);
  if (context === undefined) {
    throw new Error('useLocation must be used within a LocationProvider');
  }
  return context;
};
